var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 17.75C1.70833 17.75 1.31597 17.5868 0.989583 17.2605C0.663194 16.9341 0.5 16.5417 0.5 16.0834V4.41671C0.5 3.95837 0.663194 3.56601 0.989583 3.23962C1.31597 2.91323 1.70833 2.75004 2.16667 2.75004H9.60417L7.9375 4.41671H2.16667V16.0834H13.8333V10.2917L15.5 8.62504V16.0834C15.5 16.5417 15.3368 16.9341 15.0104 17.2605C14.684 17.5868 14.2917 17.75 13.8333 17.75H2.16667ZM11.4792 3.22921L12.6667 4.39587L7.16667 9.89587V11.0834H8.33333L13.8542 5.56254L15.0417 6.72921L9.04167 12.75H5.5V9.20837L11.4792 3.22921ZM15.0417 6.72921L11.4792 3.22921L13.5625 1.14587C13.8958 0.812541 14.2951 0.645874 14.7604 0.645874C15.2257 0.645874 15.6181 0.812541 15.9375 1.14587L17.1042 2.33337C17.4236 2.65282 17.5833 3.04171 17.5833 3.50004C17.5833 3.95837 17.4236 4.34726 17.1042 4.66671L15.0417 6.72921Z",
    fill: "#515253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit_square.2d5f8bb27707f33a15545f99a2d22887.svg";
export { ForwardRef as ReactComponent };